import axios from 'axios';
import apiConfig from '../../api.config';

export default async function changeChannelStatus(action, hotel, channel) {
  const {
    host,
    URIs: { hbxChannelChangeStatus },
  } = apiConfig;

  const uri = `${host}${hbxChannelChangeStatus}`
    .replace(':action', action)
    .replace(':hotelId', hotel)
    .replace(':channelId', channel);

  return await axios.post(uri).then(res => res.data);
}
